module.exports = __webpack_public_path__ + "img/titleist_h_visual.b053a3bc.jpg";